'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export')
  , $find   = require('./_array-methods')(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/core-js/modules/es6.array.find-index.js
// module id = ../../../../core-js/modules/es6.array.find-index.js
// module chunks = 9